// Keeps a field in the page schema without rendering it; preserveHiddenData stops recalculation deleting its data.
export const hiddenFieldUI = {
  'ui:options': { hideIf: () => true, preserveHiddenData: true },
};
